module.exports = __webpack_public_path__ + "img/Shop.bb705301.svg";